import c from './commonUtil'
// f针对数组中两个对象
export function setarrdate(fArr,rawdata,f){
    console.log(fArr,rawdata,f)
    if(f){

        rawdata.forEach((item,index)=>{
            try{
            for(let k in item[f]){
                    if(fArr[k]&&rawdata[index][f][k]){
                        rawdata[index][f][k]=c.formatDate(rawdata[index][f][k])
                    }
            }
                }catch(e){
            console.log(e);
            }
        })
    }else{
        rawdata.forEach((item,index)=>{
            try{
            for(let k in item){
                    if(fArr[k]&&rawdata[index][k]){
                        rawdata[index][k]=c.formatDate(rawdata[index][k])
                    }
            }
                }catch(e){
            console.log(e);
            }
        })
    }
    
    console.log(rawdata);
    return rawdata
}
export function setdate(raw){
    return c.formatDate(raw)
}
export function deepClone(obj){
    　　let objClone =  Array.isArray(obj) ? [] : {};
    　　if (obj && typeof obj === 'object') {
    　　　　for(let key in obj){
    　　　　　　if (obj[key] && typeof obj[key] === 'object'){
    　　　　　　　　objClone[key] = deepClone(obj[key]);
    　　　　　　}else{
    　　　　　　　　objClone[key] = obj[key]
    　　　　　　}
    　　　　}
    　　}
    　　return objClone;
    }
    // id转换成名字
export function  idturnname(idlist) {
    let idnameMap={}
   idlist.forEach(it=>{
    idnameMap[it.backaccountid]=it.name
   })
   return idnameMap
}


// WEBPACK FOOTER //
// ./src/utils/timerest.js